// Homerouter.vue
<script setup>
import { computed, defineProps, watch } from 'vue'
import { useRouter } from 'vue-router'

import MentorHome from './Dashboard.vue'
import BrochureLanding from './brochure/BrochureLanding.vue'
import { useMeetingStore } from '@/store/meetingStore'

const props = defineProps({
  session: {
    type: Object,
    default: null,
  },
})

const router = useRouter()
const meetingStore = useMeetingStore()

// Check if user has any clients/patients
const hasClients = computed(() => {
  return meetingStore.patients && meetingStore.patients.length > 0
})

// Watch for session and patient data changes to handle redirect
watch([() => props.session, () => meetingStore.patients, () => meetingStore.patientsLoading], ([newSession, newPatients, isLoading]) => {
  // Only redirect if user is logged in, data is loaded (not loading), and they have no clients
  if (newSession && !isLoading && newPatients !== undefined && newPatients.length === 0) {
    // Check if we're currently on the home route to avoid redirect loops
    // Also check that we didn't just come from the welcome page
    const currentRoute = router.currentRoute.value
    if (currentRoute.name === 'home' && currentRoute.query.from !== 'welcome') {
      console.log('User has no clients, redirecting to welcome page')
      router.replace('/welcome')
    }
  }
}, { immediate: true })
</script>

<template>
  <MentorHome v-if="session" :session="session" />
  <BrochureLanding v-else />
</template>

<style scoped>
.bg-surface {
  background-color: hsl(var(--background));
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
